import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    chevron: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export default stylesheet;
